import { render, staticRenderFns } from "./estabelecer.vue?vue&type=template&id=42f22127&scoped=true"
import script from "./estabelecer.vue?vue&type=script&lang=js"
export * from "./estabelecer.vue?vue&type=script&lang=js"
import style0 from "./estabelecer.vue?vue&type=style&index=0&id=42f22127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f22127",
  null
  
)

export default component.exports